<img src="/assets/images/logo.png" alt="KVVM" width="250" height="83">
<h2>{{ 'general.app-name' | translate }}</h2>
<form [formGroup]="otpForm" (ngSubmit)="authenticationService.loginTwoFactorAuthentication(otpForm.value)">
	<input type="hidden" name="sessionID">
	<p>{{ 'auth.two-factor-authentication-login.enter-code' | translate }}</p>
  <app-otp-input (completed)="submit($event)"></app-otp-input>
	<button color="primary" mat-button [disabled]="!otpForm.valid">{{ 'shared.actions.confirm' | translate }}</button>
</form>
<a [routerLink]="['/login-with-recovery-code']">{{ 'auth.two-factor-authentication-login.sub-action' | translate }}</a>
